/** Marks are shown Spanish-style, always with two decimals: 7,25 — never 7.25. */
export const GRADE_FORMAT = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
} as const;

/** A mark as text. Components that animate the number take {@link GRADE_FORMAT} instead. */
export function formatGrade(grade: number): string {
  return grade.toLocaleString('es', GRADE_FORMAT);
}
